const Title=({title})=>{
    return(
        <div className="text-2xl font-bold text-primary cursor-pointer leading-5 pt-5">
            {title}
        </div>
    )
}

export default Title;